import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/tmp/126ddc66/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ResourceCard = makeShortcode("ResourceCard");
const MdxIcon = makeShortcode("MdxIcon");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <AnchorLinks mdxType="AnchorLinks">
      <AnchorLink mdxType="AnchorLink">IBM Design Language</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Design kit</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Elements</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Design migration strategy</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Feedback</AnchorLink>
    </AnchorLinks>
    <h2 {...{
      "id": "ibm-design-language"
    }}>{`IBM Design Language`}</h2>
    <p>{`Carbon v10 delivers the new `}<a href="https://www.ibm.com/design/language/" target="_blank">{`IBM Design Language`}</a>{` to product teams. It represents a complete visual refresh of the system, delivering the ethos of IBM Design. With tooling and guidance on color, layout, typography, iconography, motion, patterns, and content, Carbon v10 is a modern, open-source framework for building digital products and experiences.`}</p>
    <h2 {...{
      "id": "carbon-v10-kit"
    }}>{`Carbon v10 kit`}</h2>
    <h3 {...{
      "id": "whats-new"
    }}>{`What’s new`}</h3>
    <ul>
      <li parentName="ul">{`New Sketch Cloud method of keeping your design kit in sync`}</li>
      <li parentName="ul">{`New IBM Design Language styling`}</li>
      <li parentName="ul">{`Improved kit structure`}</li>
      <li parentName="ul">{`Updated text styles`}</li>
      <li parentName="ul">{`Updated spacers`}</li>
      <li parentName="ul">{`Icon updates`}</li>
      <li parentName="ul">{`New color tokens`}</li>
      <li parentName="ul">{`Updated elements page`}</li>
      <li parentName="ul">{`New Getting Started page`}</li>
      <li parentName="ul">{`Updated layer styles`}</li>
    </ul>
    <p>{`For more details on changes to the design kit, see the What’s new page within the Sketch kit.`}</p>
    <h3 {...{
      "id": "design-kit"
    }}>{`Design kit`}</h3>
    <p>{`Carbon v10 includes a completely revised Sketch design kit, updated for the new IBM Design Language. All components, colors, icons, typography, motion, and grid elements in the kit are aligned with the new Design Language.`}</p>
    <h4 {...{
      "id": "sketch-libraries"
    }}>{`Sketch libraries`}</h4>
    <p>{`Also new in Carbon v10 is Sketch Cloud Sync for the design kit. This is a completely new way of working with the Carbon Design Kit. Designers can now subscribe to the design kit library via Sketch Cloud, and updates to the contents of the kit will be pushed to subscribers as they become available.`}</p>
    <h4 {...{
      "id": "icons-pictograms-and-the-full-ibm-color-palette"
    }}>{`Icons, pictograms, and the full IBM color palette`}</h4>
    <p>{`To access the IBM Design Language icons, pictograms, and colors, subscribe to the IBM Design Language Kit via Sketch Cloud. `}<strong parentName="p">{`Please note that all icons in the Carbon kit are now imported from the IBM Design Language library`}</strong>{`.`}</p>
    <h4 {...{
      "id": "migrating-to-v10"
    }}>{`Migrating to v10`}</h4>
    <p>{`Upgrading to the v10 kit will not automatically change any files created in previous versions of the kit. The migration of existing v9 layouts will be a manual process for designers.`}</p>
    <p>{`Although libraries from multiple versions of Carbon can exist in Sketch at the same time, you should avoid using v10 symbols in an app designed with v9.`}</p>
    <h3 {...{
      "id": "setting-up-the-kit"
    }}>{`Setting up the kit`}</h3>
    <p>{`The new method for using the kit is via Sketch Cloud subscription. Head over to our Getting started guide to set up the new Sketch libraries!`}</p>
    <Row mdxType="Row">
      <Column colLg={4} colMd={4} noGutterSm mdxType="Column">
        <ResourceCard subTitle="Getting started" href="/get-started/design" mdxType="ResourceCard">
          <MdxIcon name="codesandbox" mdxType="MdxIcon" />)
  </ResourceCard>
      </Column>
    </Row>
    <h2 {...{
      "id": "elements"
    }}>{`Elements`}</h2>
    <h4 {...{
      "id": "themes--color"
    }}>{`Themes & color`}</h4>
    <p>{`Carbon now offers four preset visual themes for IBM products, offering more options than ever for accessible components. See `}<a parentName="p" {...{
        "href": "/guidelines/themes"
      }}>{`themes guidelines`}</a>{` for detailed info on using themes in Carbon v10.`}</p>
    <p>{`Carbon color tokens also have been updated with v10 to include several new and updated color tokens.`}</p>
    <p><a parentName="p" {...{
        "href": "https://github.com/carbon-design-system/carbon/blob/master/docs/migration/10.x-color.md"
      }}>{`v10 Color migration`}</a></p>
    <h4 {...{
      "id": "icons"
    }}>{`Icons`}</h4>
    <p>{`The iconography in Carbon v10 has been significantly updated to better align with the new IBM Design Language, with dozens of new, accessible icons and design improvements to many of the existing icons. The full library of icons and pictograms is available via the IBM Design Language Kit library. Click on the tile at the top of this page to subscribe to this library.`}</p>
    <p>{`Any icons being used with Carbon v9 (outside of those integral to a component) should be reviewed against the new icons before publishing. Wherever possible, replace old icons with their revised IBM Design Language versions.`}</p>
    <p><a parentName="p" {...{
        "href": "/guidelines/iconography/library"
      }}>{`Iconography guidelines`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://github.com/carbon-design-system/carbon/blob/master/docs/migration/10.x-icons.md"
      }}>{`v10 Iconography migration`}</a></p>
    <h4 {...{
      "id": "typography"
    }}>{`Typography`}</h4>
    <p>{`The primary typeface for Carbon (IBM Plex) is unchanged from v9. However, the type token architecture has been completely redesigned for better clarity and flexibility in v10, moving from a basic type scale model to a more robust token-based architecture. Work with your development team to discuss how this new architecture might affect your team’s workflow.`}</p>
    <p><a parentName="p" {...{
        "href": "/guidelines/typography/overview"
      }}>{`Typography guidelines`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://github.com/carbon-design-system/carbon/blob/master/docs/migration/10.x-type.md"
      }}>{`v10 Typography migration`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://carbon-elements.netlify.com/type/examples/preview/"
      }}>{`v10 Typography preview`}</a></p>
    <h4 {...{
      "id": "motion"
    }}>{`Motion`}</h4>
    <p>{`Carbon v10 introduces the new IBM Design Language motion standards, designed to bring unity and cohesion to all IBM motion. All interactions that include motion should abide by these standards.`}</p>
    <p><a parentName="p" {...{
        "href": "/guidelines/motion/basics"
      }}>{`Motion guidelines`}</a></p>
    <h4 {...{
      "id": "layout-grid-and-spacing"
    }}>{`Layout, grid, and spacing`}</h4>
    <p>{`The grid has been completely redesigned for v10, to align with the IBM Design Language. The official IBM grid is now 16 columns. However, to make the migration process for v9 products smoother, Carbon v10 will default to the 12-column grid, with an option to switch to the 16-column grid. Designers starting on new layouts using v10 should use the 16-column grid.`}</p>
    <p>{`Layout and spacing token names have also been updated in v10 but the values remain the same.`}</p>
    <p><a parentName="p" {...{
        "href": "/guidelines/layout"
      }}>{`Layout guidelines`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://carbon-elements.netlify.com/grid/examples/preview/"
      }}>{`v10 grid demo`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://github.com/carbon-design-system/carbon/blob/master/docs/migration/10.x-layout.md#migrating"
      }}>{`v10 spacing migration`}</a></p>
    <h2 {...{
      "id": "design-migration-strategy"
    }}>{`Design migration strategy`}</h2>
    <h4 {...{
      "id": "update-your-kit"
    }}>{`Update your kit`}</h4>
    <p>{`The Carbon design kit now lives in a Sketch library, which can be updated on a regular basis by the Carbon team. If you’re working with a local document, visit the `}<a parentName="p" {...{
        "href": "/get-started/design"
      }}>{`Getting started`}</a>{` guide and get set up with the new libraries.`}</p>
    <p>{`The components and elements in the kit have been completely revised from v9. Be sure to note the changes to the color palette, spacing and layout, and iconography in the kit.`}</p>
    <h4 {...{
      "id": "code-first-approach"
    }}>{`“Code-first” approach`}</h4>
    <p>{`The fastest approach to v10 migration starts with the front-end developer. The developer, with help from the migration guidelines found on this site, will update the product’s front end code to v10. This should not cause any major breaks in the UI, but there might be some funky looking stuff that needs to be resolved by the design team. Product teams using v9 components in their code should see a mostly seamless transition.`}</p>
    <p>{`The product design team should review the updated UI with a critical eye and a solid knowledge of the v10 design guidelines. Throughout the process, ask yourself:`}</p>
    <ul>
      <li parentName="ul">{`Do the fonts look right?`}</li>
      <li parentName="ul">{`Are the colors correct?`}</li>
      <li parentName="ul">{`Is the spacing between components correct?`}</li>
      <li parentName="ul">{`Do animations in the UI match the new motion standards?`}</li>
      <li parentName="ul">{`Does the general layout still work, and does it express the IBM Design Language accurately and effectively?`}</li>
    </ul>
    <p>{`Working together, design and dev teams will catch and fix any problems with page layout and design.`}</p>
    <h2 {...{
      "id": "feedback"
    }}>{`Feedback`}</h2>
    <p>{`To leave feedback for the Carbon team, make suggestions for improvements, or just ask a question, you can `}<a parentName="p" {...{
        "href": "https://github.com/carbon-design-system/carbon/issues/new?template=feedback.md&labels=feedback&title=User+feedback+for+Migration+Designers+page"
      }}>{`open an issue`}</a>{` on GitHub.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      